export default __webpack_public_path__ + "static/media/oscer-pres-tinnitus.b55e0b17.svg";